<template>
	<button
		:class="{ 'has-icon': hasIcon }"
		@click.prevent="clickHandler($event)"
		class="object-link object-button"
		ref="link"
		type="button"
		v-tooltip="{content: tooltip, html: false}"
	>
		<!-- tabindex="-1"-->
		<icon v-if="hasIcon" :type="icon" color="inherit"></icon>
		<span class="object-link-text"><slot></slot></span>
		<icon
			class="right"
			color="inherit"
			type="chevron-right"
			v-tooltip="!tooltip ? trans('actions.show') : null"
		></icon>
	</button>
</template>

<script type="text/babel">
export default {
	props: {
		icon: { default: null }, // icon name (file)
		prevent: { default: true },
		tooltip: { default: null },
	},

	methods: {
		clickThroughPopover() {
			this.$refs.link.click();
		},

		clickHandler(event) {
			if (this.prevent) {
				event.stopPropagation();
				event.preventDefault();
			}

			this.$emit("clicked");
		},
	},

	computed: {
		hasIcon() {
			return this.icon !== null;
		},
	},
};
</script>
